var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 7.5045C11.8435 7.5045 13.3359 8.99689 13.3359 10.8378C13.3359 12.6788 11.8435 14.1712 10.0026 14.1712C8.16163 14.1712 6.66925 12.6788 6.66925 10.8378C6.66925 8.99689 8.16163 7.5045 10.0026 7.5045ZM10.0026 4.58398C13.8472 4.58398 17.166 7.20899 18.0868 10.8876C18.1707 11.2225 17.9672 11.5619 17.6323 11.6457C17.2975 11.7295 16.9581 11.526 16.8743 11.1912C16.0919 8.06562 13.2704 5.83398 10.0026 5.83398C6.73336 5.83398 3.911 8.06754 3.12996 11.1949C3.04633 11.5298 2.70704 11.7335 2.37215 11.6499C2.03726 11.5662 1.83357 11.227 1.91721 10.8921C2.83645 7.21125 6.15632 4.58398 10.0026 4.58398Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/eye-show.59176031f249177debb727d0cd3d1832.svg";
export { ForwardRef as ReactComponent };